import { isImpersonating } from '~services/sessionTokens';
import { useStores } from '~store';

import { resolveBillingBannerState } from './billingBannerState';

export default function useBillingBannerState() {
  const { userStore } = useStores();

  return resolveBillingBannerState({
    billingStatus: userStore.userCompany.billingStatus ?? null,
    companyId: userStore.userCompany.id,
    isImpersonating: isImpersonating(),
  });
}
